__turbopack_context__.v({
  "centered": "ContentContainer-module-scss-module__ZAs4AW__centered",
  "contentContainer": "ContentContainer-module-scss-module__ZAs4AW__contentContainer",
});
